import { 
  TrophyIcon, 
  FlagIcon, 
  UserGroupIcon, 
  LightBulbIcon, 
  GlobeAltIcon, 
  CheckCircleIcon 
} from '@heroicons/react/24/outline';

const IntegrationBenefitsSection = () => {
  const integrationBenefits = [
    {
      icon: TrophyIcon,
      title: "White-Label Solutions",
      description: "Complete platform customization with your branding, messaging, and user experience"
    },
    {
      icon: FlagIcon, 
      title: "Custom Implementation",
      description: "Tailored integration that fits your existing workflows and technology stack"
    },
    {
      icon: UserGroupIcon,
      title: "Dedicated Support",
      description: "Dedicated account management, training, and ongoing technical support"
    },
    {
      icon: LightBulbIcon,
      title: "Co-Innovation",
      description: "Joint development opportunities and shared go-to-market strategies"
    },
    {
      icon: GlobeAltIcon,
      title: "Market Expansion", 
      description: "Marketing co-op opportunities and revenue sharing programs"
    },
    {
      icon: CheckCircleIcon,
      title: "Early Mover Advantage",
      description: "Join as a founding partner and shape how the platform serves your industry"
    }
  ];

  return (
    <section className="py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Why Partner With Us</h2>
            <p className="text-xl text-muted-foreground">
              Comprehensive support to help you succeed with SeniorThrive integration
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {integrationBenefits.map((benefit, index) => (
              <div key={index} className="flex items-start gap-4 glass-card p-6 rounded-xl hover-scale">
                <benefit.icon className="w-8 h-8 text-primary flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold mb-2">{benefit.title}</h3>
                  <p className="text-sm text-muted-foreground">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationBenefitsSection;